// mobile phone resolution

function areaSelectAction() {
    var areaSelectionBtn = document.querySelector(".AreaSelectionBtn");
    var areaSelectionList = document.querySelector(".AreaSelectionList");
    if(!areaSelectionBtn || !areaSelectionList) return;
    areaSelectionBtn.addEventListener("click", function () {
        var res = hasClass(areaSelectionBtn, "AreaSelectionBtnActive");
        if (!!~res.index) {
            removeClass(areaSelectionBtn, "AreaSelectionBtnActive");
            removeClass(areaSelectionList, "AreaSelectionAction");
            unlockBodyScroll();
        } else {
            addClass(areaSelectionBtn, "AreaSelectionBtnActive");
            addClass(areaSelectionList, "AreaSelectionAction");
            lockBodyScroll();
        }
    });
}

areaSelectAction();

function lockBodyScroll() {
    document.querySelector("body").setAttribute("style", "overflow: hidden");
}

function unlockBodyScroll() {
    document.querySelector("body").setAttribute("style", "");
}

var dataSource = window.dataSource;

function createElement(domType, attributes) {
    var dom = document.createElement(domType);
    if(!attributes) return dom;
    for (var attr in attributes) {
        dom.setAttribute(attr, attributes[attr]);
    }
    return dom;
}

// 选择地区 pc
renderLeftPart(dataSource);
renderRightPart(dataSource);
selectionActive();

// render left part
function renderLeftPart(dataSource) {
    var domAreaSelection = createElement("ul", {class: "AreaSelection"});
    var target = document.querySelector(".AreaSelectionWrapper");
    if(!target) return;
    target.appendChild(domAreaSelection);
    renderProvinces(dataSource, domAreaSelection);
}

function renderProvinces(sourceData, parent) {
    for (var n = 0; n < sourceData.length; n++) {
        var dom = renderProvince(sourceData[n]);
        parent.appendChild(dom)
    }
}

function renderProvince(provinceData) {
    var domLi = createElement("li", {class: "AreaSelectionItem"});
    var domDivLeft = createElement("div", {class: "AreaSelectionItemLeft"});
    domDivLeft.innerHTML = provinceData.id;
    var domDivRight = createElement("div", {class: "AreaSelectionItemRight"});

    var childrenData = provinceData.children
    for (var n = 0; n < childrenData.length; n++) {
        var domA = createElement("a", {href: "javascript:;", "data-id": childrenData[n].id});
        domA.innerHTML = childrenData[n].province;
        // add click event
        domA.addEventListener("click", animation)
        domDivRight.appendChild(domA);
    }

    domLi.appendChild(domDivLeft);
    domLi.appendChild(domDivRight);

    return domLi;
}

function cleanCurrentStyle() {
    $(".AreaSelectionItemRight a").removeClass("current");
}

function animation() {
    var _id = this.getAttribute("data-id");
    // Remove this class name from other elements
    cleanCurrentStyle();
    // Add a class name to the element that was clicked
    this.classList.add("current");


    if (!_id) return;
    setTimeout(function() {
        var target = document.getElementById(_id);
        $(target.offsetParent).animate({
            scrollTop: (target.offsetTop || 0)
        }, 500);
    }, 20);
}

// render right part
function renderRightPart(dataSource) {
    const target = document.querySelector(".AreaSelectionWrapper");
    if(!target) return;
    const domRegionWrapper = createElement("div", {class: "regionWrapper"});
    target.appendChild(domRegionWrapper);
    const domCloseBtn = renderCloseBtn();
    domRegionWrapper.appendChild(domCloseBtn);
    renderRegionContent(dataSource, domRegionWrapper);
}

function renderCloseBtn() {
    var dom = createElement("div", {class: "closeBtnWrapper"});
    var domBtn = createElement("button", {class: "closeBtn"});
    var domImg = createElement("img", {src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAPCAYAAAA71pVKAAAAAXNSR0IArs4c6QAAAKVJREFUOE9jnDlzpu6/f/84MzMzTzEQCaZPn27GxMT0nRHEYGBg2MzMzByWlpZ2kJD+WbNm2f/9+3cVAwODLyNIMUyAkAHo6sCaiTEAmwVwzfgMwOUyFM3YDMDnJQzNyAYwMDD0MjAwFOMKC6yaQQZMnz69jIGBoZOBgaE8MzOzC1ssUNdmdD8S7WdcCgmGNqGEgjOeCWnElZAoS9vk5qo/f/58BwDpTcPkdiMfQgAAAABJRU5ErkJggg=="});
    domBtn.appendChild(domImg);
    dom.appendChild(domBtn);
    dom.addEventListener("click", closeActiveHandler);
    return dom;
}

function renderRegionContent(datasource, parent) {
    var domRegionContent = createElement("div", {class: "regionContent"});
    var domRegion = renderRegion(datasource);
    domRegionContent.appendChild(domRegion);
    parent.appendChild(domRegionContent);
}

function renderRegion(datasource) {
    var domRegion = createElement("ul", {class: "region"});
    for (var n = 0; n < datasource.length; n++) {
        renderRegionLi(datasource[n].children, domRegion);
    }
    return domRegion;
}

function renderRegionLi(data, parent) {
    for (var n = 0; n < data.length; n++) {
        var domLi = createElement("li", {id: data[n].id});
        var domProvinceName = createElement("div", {class: "provinceName"});
        domProvinceName.innerHTML = data[n].province;
        domLi.appendChild(domProvinceName);
        parent.appendChild(domLi);
        renderCity(data[n].children, domLi);
    }
}

function renderCity(data, parent) {
    var domCity = createElement("ul", {class: "city"});
    for (var n = 0; n < data.length; n++) {
        var domLi = createElement("li");
        var domA = createElement("a", {target: "_blank", href: data[n].href});
        domA.innerHTML = data[n].city;
        domLi.appendChild(domA);
        domCity.appendChild(domLi);
    }
    parent.appendChild(domCity);
}

function selectionActive() {
    var domAreaSelection = document.querySelector(".AreaSelection");
    if(!domAreaSelection) return;
    domAreaSelection.addEventListener("click", showActionHandler);
}

function closeActiveHandler() {
    var domRegionWrapper = document.querySelector(".regionWrapper");
    domRegionWrapper.setAttribute("style", "display: none");
    cleanCurrentStyle();
}

function showActionHandler() {
    var domRegionWrapper = document.querySelector(".regionWrapper");
    domRegionWrapper.setAttribute("style", "display: block");
}

// 选择地区 mobile

renderAreaBlockWrapper();
renderLetterList();

function renderAreaBlockWrapper() {
    var parentDom = document.querySelector(".AreaSelectionMobile");
    if(!parentDom) return;
    var domAreaBlockWrapper = createElement("div", {class: "AreaBlockWrapper"});
    for(var n=0;n<dataSource.length; n++) {
        renderAreaBlock(dataSource[n], domAreaBlockWrapper);
    }

    parentDom.appendChild(domAreaBlockWrapper);
}

function renderAreaBlock(data, parent) {
    var domAreaBlock = createElement("div", {class: "AreaBlock"});
    var domAreaBlockLetter = createElement("div", {class: "AreaBlockLetter"});

    domAreaBlockLetter.innerHTML = data.id;
    domAreaBlockLetter.setAttribute("id", data.id);
    domAreaBlock.appendChild(domAreaBlockLetter);
    renderAreaList(data.children, domAreaBlock);
    parent.appendChild(domAreaBlock);
}

function renderAreaList(data, parent) {

    for(var n=0; n<data.length; n++) {

        var domUl = createElement("ul");
        var firstLi = createElement("li", {class: "province"});
        firstLi.innerHTML = data[0].province;
        domUl.appendChild(firstLi);
        var childrenData = data[n].children;
        for(var i=0; i<childrenData.length; i++) {
            var domLi = createElement("li", {class: "city"});
            domLi.innerHTML = childrenData[i].city;
            domUl.appendChild(domLi);
        }
    }

    parent.appendChild(domUl);
}

function renderLetterList(){
    var parentDom = document.querySelector(".AreaSelectionMobile");
    if(!parentDom) return;
    var domLetterList = createElement("ul", {class: "letterList"});
    for(var n=0; n<dataSource.length; n++) {
        var domLi = createElement("li");
        domLi.innerHTML = dataSource[n].id;
        domLi.addEventListener("click", function(event){

           const _target = document.getElementById(`${event.target.innerHTML}`);
           const scrollTop = _target.offsetTop;
           $(".AreaBlockWrapper").animate({
               scrollTop
           }, 500);
        });
        domLetterList.appendChild(domLi);
    }
    parentDom.appendChild(domLetterList);
}

$(document).ready(function(){
    $(".letterList").on("touchmove", function(event){
        var touch = event.touches[0];
        var x = touch.clientX - $(this).offset().left;
        var y = touch.clientY - $(this).offset().top;
        console.log("x: " + x + ", y: " + y);
    });
});


// body padding-bottom value is equal as footer's height value
const initBodyPaddingBottom = () => {
/*    const domFooter = document.querySelector(".footer");
    const domBody = document.querySelector("body");
    if(!domFooter || !domBody) return;
    const height = (getComputedStyle(domFooter).height) || 0;
    domBody.setAttribute("style", `padding-bottom: ${height}`);*/

    const height = $(".footerWrapper").height() || 0;
    $("body").css({"paddingBottom": height});

};

window.onload = window.onresize = initBodyPaddingBottom;



// partnerships select action
const partnershipsSelectAction = () => {
  const target = document.querySelector(".footerRightLinks");
  if(target)target.addEventListener("click", selectActionHandler);
};

function selectActionHandler() {
    const target = document.querySelector(".footerRightLinksList");
    // target.setAttribute("style", "display: block");
    if(target.style.display === "block"){
        // target.style.display = "none";  // 这句不要了, 因为页脚链接不想隐藏
    }else{
        target.style.display = "block";
    }
}

partnershipsSelectAction();

// todo 手机设备下 首页展开查看更多


// 关于我们导航
if (document.querySelector("#map-container")) {

        window.map = new BMap.Map("map-container");
        map.centerAndZoom(new BMap.Point(121.55467,38.883643),17);
        map.enableScrollWheelZoom(true);

        function ComplexCustomOverlay(point, text, mouseoverText){
            this._point = point;
            this._text = text;
            this._overText = mouseoverText;
        }
        ComplexCustomOverlay.prototype = new BMap.Overlay();
        ComplexCustomOverlay.prototype.initialize = function(map){
            this._map = map;
            var div = this._div = document.createElement("div");
            div.style.position = "absolute";
            div.style.zIndex = BMap.Overlay.getZIndex(this._point.lat);
            div.style.backgroundColor = "#EE5D5B";
            div.style.border = "1px solid #bc3b3a";
            div.style.color = "white";
            div.style.padding = "2px";
            div.style.lineHeight = "18px";
            div.style.whiteSpace = "nowrap";
            div.style.MozUserSelect = "none";
            div.style.fontSize = "12px";
            var span = this._span = document.createElement("span");
            div.appendChild(span);
            span.appendChild(document.createTextNode(this._text));

            var arrow = this._arrow = document.createElement("div");
            arrow.style.background = "url(http://map.baidu.com/fwmap/upload/r/map/fwmap/static/house/images/label.png) no-repeat";
            arrow.style.position = "absolute";
            arrow.style.width = "11px";
            arrow.style.height = "10px";
            arrow.style.top = "22px";
            arrow.style.left = "10px";
            arrow.style.overflow = "hidden";
            div.appendChild(arrow);

            div.onmouseover = function(){
                this.style.backgroundColor = "#6BADCA";
                this.style.borderColor = "#5188a5";
                arrow.style.backgroundPosition = "0px -20px";
            }

            div.onmouseout = function(){
                this.style.backgroundColor = "#EE5D5B";
                this.style.borderColor = "#bc3b3a";
                arrow.style.backgroundPosition = "0px 0px";
            }

            map.getPanes().labelPane.appendChild(div);

            return div;
        }
        ComplexCustomOverlay.prototype.draw = function(){
            var map = this._map;
            var pixel = map.pointToOverlayPixel(this._point);
            this._div.style.left = pixel.x - parseInt(this._arrow.style.left) + "px";
            this._div.style.top  = pixel.y - 30 + "px";
        }


            var sw = 121.55467;
            var ne = 38.883643;
            var text = "我在这";
            if(sw){
                var myCompOverlay = new ComplexCustomOverlay(new BMap.Point(sw,ne), text);
                map.addOverlay(myCompOverlay);
                map.panTo(new BMap.Point(sw,ne));
            };

}

// 点击学习流程弹出对话框
let layerIndex = -1;

function showLayer() {
    layerIndex = layer.open({
        type: 1,
        title: '<div class="StudyLayerTitle"><span>学习流程</span></div>',
        area: ['800px', '600px'], //宽高
        content: $("#StudyLayer")
    });
}

function closeLayer() {
    layer.close(layerIndex);
}

if(document.querySelector(".studyFlow")) document.querySelector(".studyFlow").addEventListener("click", showLayer);

// 登录框

function showLoginLayer() {
    layerIndex = layer.open({
        type: 1,
        title: '<div class="LoginLayerTitle"><span>学员登录</span></div>',
        area: '400px', //宽高
        content: $("#LoginLayer")
    });
}

if(document.querySelector(".loginBtn")) document.querySelector(".loginBtn").addEventListener("click", showLoginLayer);

// 注册框

function RegisterLayer() {
    const url = this.getAttribute("data-link");
    if(url) window.location.href = url;
}

if(document.querySelector(".registerBtn")) document.querySelector(".registerBtn").addEventListener("click", RegisterLayer);




/** WEBPACK FOOTER **
 ** ./src/website.js
 **/